import { useRef } from 'react';
import {
  clearTokensOnce,
  TokenMigrationResult,
} from '../utilities/localStorage';

/**
 * Token migration'ını uygulama ağacında bir kez çalıştırır ve sonucu loglar.
 *
 * Temizlik bilerek effect'te değil render sırasında yapılır: checkToken
 * oturum kontrolünü session üzerinden yaptığı için, migration ondan önce
 * çalışmazsa eski token ile getMe isteği atılır ve migration etkisiz kalır.
 * clearTokensOnce idempotent olduğundan tekrar çağrılması güvenlidir.
 */
const useClearTokensOnce = (): TokenMigrationResult => {
  const resultRef = useRef<TokenMigrationResult>();

  if (!resultRef.current) {
    const result = clearTokensOnce();
    resultRef.current = result;

    console.info(
      '[token-migration]',
      result.migrated
        ? `temizlendi: ${
            result.clearedKeys.join(', ') || 'temizlenecek kayit yoktu'
          } (onceki surum: ${result.fromVersion ?? 'yok'}, yeni surum: ${
            result.toVersion
          })`
        : `atlandi, zaten surum ${result.toVersion}`
    );
  }

  return resultRef.current;
};

export default useClearTokensOnce;
